import { render, staticRenderFns } from "./add-new-business-form.vue?vue&type=template&id=22627ac7&"
import script from "./add-new-business-form.vue?vue&type=script&lang=ts&"
export * from "./add-new-business-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports